import { ItemType } from '../FilterableListTypes'

export const modifyRelatedJobItem = (item: ItemType) => {
  item.tagValue = item.primaryLocation
  item.dateString = item.jobFunction
  return item
}
